import { trainersApi } from "api";
import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";

import { useTrainerGroupsOptions } from "../../api/hooks";
import { TrainerForm, TrainerFormValues } from "./TrainerForm/TrainerForm";
import { getApiErrorMessage, useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useQueryClient } from "@tanstack/react-query";

export const TrainersCreatePage = (): JSX.Element | null => {
  const queryClient = useQueryClient();
  const { loading: loadingGroups, options } = useTrainerGroupsOptions();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: TrainerFormValues) => {
    try {
      await trainersApi.create(data);
      navigate(routes.TRAINERS);
      showSuccess("Trener został dodany");
    } catch (error) {
      showError(getApiErrorMessage(error, "Nie udało się dodać trenera"));
      console.error(error);
    } finally {
      queryClient.invalidateQueries({
        queryKey: ["trainersList"],
      });
    }
  };

  if (loadingGroups) return null;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Trenerzy", path: routes.TRAINERS }, { title: "Tworzenie nowego trenera" }]}
        headerText="Tworzenie nowego trenera"
      />
      <TrainerForm onSubmit={onSubmit} groupsOptions={options} />
    </PageMain>
  );
};
